import { render, staticRenderFns } from "./CertificadoMostrar.vue?vue&type=template&id=be9777ee"
import script from "./CertificadoMostrar.vue?vue&type=script&lang=js"
export * from "./CertificadoMostrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports